"use client";

import clsx from "clsx";
import {
	BellIcon,
	CirclePlusIcon,
	LayersIcon,
	LockKeyhole,
	MapIcon,
	MapPinPlusIcon,
	UsersIcon,
} from "lucide-react";
import { motion } from "motion/react";
import type React from "react";

export const Hook1 = () => {
	return (
		<h1 className="text-6xl rounded-full font-bold leading-[1.1] tracking-tighter text-primary">
			<span className="bg-clip-text font-normal text-5xl text-transparent bg-primary-64">
				Unlock
			</span>
			<LockKeyhole className="p-3 h-full w-12 rotate-45 text-green-600 inline-block animate-bounce" />
			<br />
			<div className="relative w-fit text-on-surface dark:text-on-surface-dark">
				<GradientText text="Your Live" />
				<span className="absolute top-2 size-3 rounded-full bg-red-500 text-xs font-medium">
					<span className="inline-block size-3 animate-ping rounded-full bg-red-500 motion-reduce:animate-none" />
				</span>
			</div>
			<span className="text-primary font-extrabold text-7xl">City Maps</span>
		</h1>
	);
};

export const Hook2 = () => {
	return (
		<h1 className="flex flex-col gap-0.5 text-6xl rounded-full font-bold tracking-[-0.035em] text-primary">
			<span className="font-bold text-4xl text-red-500">
				Live
				<span className="inline-block align-top mt-1 size-1 animate-ping rounded-full bg-red-500 motion-reduce:animate-none" />
			</span>
			<span className="font-bold text-4xl text-primary-34">Share</span>
			<span className="font-bold text-4xl text-primary-34">Create</span>
			<span className="font-bold text-4xl text-primary">Explore</span>
			<span className="font-bold text-4xl text-primary">Communities</span>
			{/* <span className="font-bold text-4xl text-primary-34">Nearby Maps in</span> */}
			<span
				className="sticker mt-2 drop-shadow-2xl drop-shadow-primary"
				data-text="Your City"
			>
				<span>Your City</span>
			</span>
		</h1>
	);
};

export const Hook3 = () => {
	return (
		<h1 className="flex flex-col gap-0.5 text-6xl rounded-full font-bold tracking-[-0.035em] text-primary">
			<span className="font-bold text-5xl text-primary-64">
				<span className="text-primary font-extrabold text-7xl">Explore</span>{" "}
				<br />
				<span className="text-primary-64 text-3xl">
					Everything Happening In
				</span>{" "}
				<br />
			</span>
			<span
				className="sticker my-2 drop-shadow-2xl drop-shadow-primary"
				data-text="Your City"
			>
				<span>Your City</span>
			</span>
			<div className="flex my-2 flex-row gap-2">
				<span className="font-bold text-3xl text-red-500">
					Live
					<span className="inline-block align-top mt-1 size-1 animate-ping rounded-full bg-red-500 motion-reduce:animate-none" />
				</span>
				<span className="font-bold text-3xl text-green-500">
					Nearby
					<span className="inline-block align-top mt-1 size-1 animate-ping rounded-full bg-green-500 motion-reduce:animate-none" />
				</span>
				<span className="font-bold text-3xl text-yellow-400">
					One Map
					<span className="inline-block align-top mt-1 size-1 animate-ping rounded-full bg-yellow-400 motion-reduce:animate-none" />
				</span>
			</div>
		</h1>
	);
};

export const Hook4 = () => {
	return (
		<h1 className="flex flex-col gap-0.5 text-6xl rounded-full font-bold tracking-[-0.035em] text-primary">
			<span className="font-bold text-5xl text-primary-64">
				<span className="text-primary font-extrabold text-5xl">Explore</span>{" "}
				<br />
				<span className="text-primary-64 text-4xl">The best local maps of</span>{" "}
				<br />
			</span>
			<span
				className="sticker my-2 drop-shadow-2xl drop-shadow-primary"
				data-text="Your City"
			>
				<span>Your City</span>
			</span>
		</h1>
	);
};

export const Hook5 = () => {
	return (
		<h1 className="flex flex-col gap-0.5 text-6xl rounded-full font-bold tracking-[-0.035em] text-primary">
			<span className="font-bold text-5xl text-primary-64">
				<span className="text-primary font-extrabold text-7xl">Explore</span>{" "}
				<br />
				<span className="text-primary-64 text-4xl">
					What&apos;s Happening in
				</span>{" "}
				<br />
				{/* <span className="text-primary-64 text-4xl">The best local maps of</span> <br /> */}
			</span>
			<span
				className="sticker my-2 drop-shadow-2xl drop-shadow-primary"
				data-text="Your City"
			>
				<span>Your City</span>
			</span>
			<ul className="flex mt-6 mb-4 text-2xl flex-col gap-0.5 list-disc pl-8 tracking-[-0.05em]">
				<li className="font-bold text-red-500">
					Live
					<span className="inline-block align-top mt-1 size-1 animate-ping rounded-full bg-red-500 motion-reduce:animate-none" />{" "}
					{""}
					<span className="font-semibold text-primary-64">
						Maps{" "}
						<MapIcon className="inline-block size-5 align-middle h-full m-1 text-primary" />
					</span>
				</li>
				<li className="font-semibold text-primary-64">
					Nearby <span className="text-primary">Communities</span>{" "}
					<UsersIcon className="inline-block size-5 align-middle h-full m-1 text-primary" />
				</li>
				<li className="font-semibold text-primary-64">
					<span className="font-semibold text-primary">Create</span> & Share{" "}
					<CirclePlusIcon className="inline-block size-5 align-middle h-full m-1 text-primary" />
				</li>
				<li className="font-semibold text-primary-64">
					Subscribe &{" "}
					<span className="font-semibold text-primary">Get Notified</span>{" "}
					<BellIcon className="inline-block size-5 align-middle h-full m-1 text-primary" />
				</li>
			</ul>
		</h1>
	);
};

export const Hook6 = () => {
	return (
		<motion.div
			initial={{ opacity: 0, filter: "blur(4px)", y: 10 }}
			animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
			transition={{
				duration: 0.3,
				delay: 0.1,
				ease: "easeInOut",
			}}
			className="mr-1"
		>
			<div className="flex flex-col gap-0.5 rounded-full font-bold tracking-[-0.035em] text-primary items-center">
				<ul className="flex mt-2 mb-2 text-base lg:text-lg xl:text-xl flex-col gap-1 tracking-[-0.05em]">
					<li className="font-semibold text-primary-64">
						<MapPinPlusIcon className="inline-block size-5 align-middle h-full mx-4 text-primary" />
						Explore Your <span className="text-primary">City</span> &{" "}
						<span className="text-primary">Places</span>
					</li>
					<li className="font-semibold text-primary-64">
						<LayersIcon className="inline-block size-5 align-middle h-full mx-4 text-primary" />
						Custom <span className="text-primary">Maps</span> & Layers
					</li>
					<li className="font-semibold text-primary-64">
						<UsersIcon className="inline-block size-5 align-middle h-full mx-4 text-primary" />
						Nearby <span className="text-primary">Communities</span>
					</li>
					<li className="font-semibold text-primary-64">
						<CirclePlusIcon className="inline-block size-5 align-middle h-full mx-4 text-primary" />
						<span className="font-semibold text-primary">Create</span> & Share
					</li>
					<li className="font-semibold text-primary-64">
						<BellIcon className="inline-block size-5 align-middle h-full mx-4 text-primary" />
						Subscribe &{" "}
						<span className="font-semibold text-primary">Get Notified</span>
					</li>
				</ul>
			</div>
		</motion.div>
	);
};

export const GradientText = ({ text }: { text: string }) => {
	return (
		<span
			className={clsx(
				"inline-block text-transparent drop-shadow-xl py-2 pr-1 text-6xl font-extrabold",
				"bg-clip-text bg-[radial-gradient(circle_at_0_0,#099ef1_0%,#6863f8_18.82%,#d84ffa_32.6%,#f058c5_52.83%,#ff4f90_68.03%,#ff6558_87.66%,#ff891f_100%)]",
			)}
		>
			{text}
		</span>
	);
};

export function MotionText({ children }: { children: React.ReactNode }) {
	return (
		<motion.span
			initial={{ opacity: 0, filter: "blur(4px)", y: 10 }}
			animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
			transition={{
				duration: 0.3,
				delay: 0.1,
				ease: "easeInOut",
			}}
			className="inline-block"
		>
			{children}
		</motion.span>
	);
}
